import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { 
  Dialog,
  DialogContent,
  Typography,
} from '@material-ui/core';
import ImageCarousel from 'components/layout/ImageCarousel/ImageCarousel';
import { withStyles } from '@material-ui/core/styles';
import { appNotify } from 'store/actions';
import CloseableDialogTitle from 'components/layout/CloseableDialogTitle';

const InspectionDialog = ({ isOpen, onClose, classes, inspectionFileUrl, inspectionJson, appNotify }) => {
  const getInnerContent = () => {
    let innerContent;
    if (inspectionFileUrl) {
      innerContent = <iframe src={inspectionFileUrl} className={classes.iframe} title="Inspection"></iframe>;
    } else if (inspectionJson) {
      let response = JSON.parse(inspectionJson);
      if (response.ImageDetails && response.ImageDetails.length > 0) {
        let imageSources = [{
          source: 'Inspection',
          images: response.ImageDetails.filter(i => i.IsThumbnail && i.Url && i.Url.length > 0).map((i, index) => ({
            id: index,
            caption: null,
            imageUrl: i.Url,
            source: 'Inspection',
            sortOrder: index + 1
          }))
        }];
        innerContent = <ImageCarousel imageSources={imageSources} />;
      }
    }
    if (innerContent != null) {
      return (
        <Dialog open={isOpen} onClose={onClose} maxWidth={false} className={classes.overrideDialogModalRoot} classes={{ paper: classes.viewInspectionDialogPaper }} >
          <CloseableDialogTitle onClose={onClose}>
            <Typography variant='h6'>Inspection Results</Typography>
          </CloseableDialogTitle>
          <DialogContent className={classes.dialogContent}>
            {innerContent}
          </DialogContent>
        </Dialog>
      );
    }
    appNotify('Cannot view inspection', 'warning');
    onClose();
    return null;
  };

  return (
    <>
      { isOpen && getInnerContent() }
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  appNotify: message => dispatch(appNotify(message))

});

const styles = theme => ({
  overrideDialogModalRoot: {
    zIndex: 2
  },
  viewInspectionDialogPaper: {
    width: '85vw',
    height: '85vh',
    overflow: 'hidden'
  },
  dialogContent: {
    height: '100%',
    padding: 0,
    margin: '0 -1px -6px'
  },
  iframe: {
    width: '100%',
    height: 'calc(100% - 6px)'
  }
});

export default compose(withStyles(styles), 
  connect(null, mapDispatchToProps)
)(InspectionDialog);